module.exports = __webpack_public_path__ + "static/media/saconst.3fe964de.png";